import {
  SET_TAGS,
  ADD_TAG_TO_CONTACT,
  DELETE_TAG_FROM_CONTACT,
  ADD_TAG_TO_EMPLOYER,
  DELETE_TAG_FROM_EMPLOYER,
  ADD_TAG_TO_ATTENDANCE,
  DELETE_TAG_TO_ATTENDANCE,
} from '../../mutation-types';

const normalizeArray = (v) =>
  Array.isArray(v) ? v : typeof v === 'string' ? v.split(',') : [];

const ensureProtocolMap = (state) => {
  if (!state.attendanceTagsByProtocol) {
    state.attendanceTagsByProtocol = {};
  }
  if (!state.attendanceTagItemsByProtocol) {
    state.attendanceTagItemsByProtocol = {};
  }
};

const mutations = {
  [SET_TAGS](state, payload) {
    if (Array.isArray(payload)) {
      state.tags = payload;
      return;
    }

    const { data = [], tag_type } = payload || {};
    state.tags = data;
    if (tag_type) {
      const types = normalizeArray(tag_type);
      types.forEach((t) => {
        if (!state.tagsByType[t]) state.tagsByType[t] = [];
        state.tagsByType[t] = data;
      });
    }
  },

  [ADD_TAG_TO_CONTACT](state, tags) {
    state.tagsToContact = tags;
  },

  [ADD_TAG_TO_EMPLOYER](state, tags) {
    state.tagsToEmployer = tags;
  },

  [DELETE_TAG_FROM_CONTACT](state, tags) {
    state.tagsToContact = tags;
  },

  [DELETE_TAG_FROM_EMPLOYER](state, tags) {
    state.tagsToEmployer = tags;
  },

  [ADD_TAG_TO_ATTENDANCE](state, payload) {
    // payload: { protocol, data, byGroup? }
    ensureProtocolMap(state);
    const { protocol, data, byGroup } = payload || {};
    state.attendanceTagsByProtocol[protocol] = data;

    if (byGroup) {
      if (!state.attendanceTagItemsByProtocol[protocol]) {
        state.attendanceTagItemsByProtocol[protocol] = {};
      }
      Object.keys(byGroup).forEach((groupId) => {
        state.attendanceTagItemsByProtocol[protocol][groupId] =
          byGroup[groupId];
      });
    }
  },

  [DELETE_TAG_TO_ATTENDANCE](state, payload) {
    // payload: { protocol, data, byGroup? }
    ensureProtocolMap(state);
    const { protocol, data, byGroup } = payload || {};
    state.attendanceTagsByProtocol[protocol] = data;

    if (byGroup) {
      if (!state.attendanceTagItemsByProtocol[protocol]) {
        state.attendanceTagItemsByProtocol[protocol] = {};
      }
      Object.keys(byGroup).forEach((groupId) => {
        state.attendanceTagItemsByProtocol[protocol][groupId] =
          byGroup[groupId];
      });
    }
  },
};

export default mutations;
